module.exports = __webpack_public_path__ + "img/logo_Guyra_Paraguay.63001708.png";